var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "play_circle"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2338_5916",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: -0.382812,
    y: 0.240967,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2338_5916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "play_circle_2",
    d: "M9.11719 16.741L16.1172 12.241L9.11719 7.74097V16.741ZM11.6172 22.241C10.2339 22.241 8.93385 21.9785 7.71719 21.4535C6.50052 20.9285 5.44219 20.216 4.54219 19.316C3.64219 18.416 2.92969 17.3576 2.40469 16.141C1.87969 14.9243 1.61719 13.6243 1.61719 12.241C1.61719 10.8576 1.87969 9.55763 2.40469 8.34097C2.92969 7.1243 3.64219 6.06597 4.54219 5.16597C5.44219 4.26597 6.50052 3.55347 7.71719 3.02847C8.93385 2.50347 10.2339 2.24097 11.6172 2.24097C13.0005 2.24097 14.3005 2.50347 15.5172 3.02847C16.7339 3.55347 17.7922 4.26597 18.6922 5.16597C19.5922 6.06597 20.3047 7.1243 20.8297 8.34097C21.3547 9.55763 21.6172 10.8576 21.6172 12.241C21.6172 13.6243 21.3547 14.9243 20.8297 16.141C20.3047 17.3576 19.5922 18.416 18.6922 19.316C17.7922 20.216 16.7339 20.9285 15.5172 21.4535C14.3005 21.9785 13.0005 22.241 11.6172 22.241Z",
    fill: "#F7F9FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/play_circle.77c198c2307ecc5007bc1cee29dc65ab.svg";
export { ForwardRef as ReactComponent };